import { Avatar, Box, Button, Drawer, Grid, Modal, Stack, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import { AddIcon, DotIcon } from '../../Components/Icons/Icons';
import { AppColors } from '../../Utils/helper/AppColors';
import StatisticsCard from './Components/StatisticsCard';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import { MdFilterList } from 'react-icons/md';
import { AiOutlineClockCircle, AiOutlineDollar } from 'react-icons/ai';
import SelectViewModal from './Components/SelectViewModal';
import { DASHBOARD_VIEWS } from '../../Utils/helper/AppConstants';
import CultService from '../../Services/CultService';
import toast from 'react-hot-toast';
import PageLoader from '../../Components/PageLoader';
import LineGraphCard from './Components/LineGraphCard';
import FooterCard from './Components/FooterCard';
import { useSelector } from 'react-redux';
import FilterSelection from '../../Components/FilterSelection';
import { useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../Routes/Pathname';
import CreateCampaignModal from '../Campaign/Components/CreateCampaignModal';
import InfoCards from './Components/HeaderInfoCards';
import dashBoardBgImg from '../../Assets/Image/image 9.png';
import DashboardEmptyView from './Components/DashboardEmptyView';
import { values } from 'lodash';
import ConversationList from './Components/ConversationList';
import HarassmentSuicidalTendency from './Components/HarassmentSuicidalTendency';
import dayjs from 'dayjs';
import PlayingModal from '../Recordings/Components/PlayingModal';
import CampaignCreateOrDuplicateModal from '../Campaign/Components/CampaignCreateOrDuplicateModal';
import CampaignSelectDialog from './Components/CampaignSelectDialog';
import CustomInfoTooltip from '../../Components/CustomInfoTooltip';
import { getColorSettings } from '../../Utils/helper/commonUtils';
import BarGraphCard from './Components/BarGraphCard';
import PieGraphCard from './Components/PieGraphCard';

export default function Dashboard() {
	const [loading, setLoading] = useState(false);
	const [viewModal, setViewModal] = useState(false);
	const [filterDrawer, setFilterDrawer] = useState(false);
	const navigate = useNavigate();
	const [filters, setFilters] = useState([]);
	const [open, setOpen] = useState(false);

	const [openCreateModal, setOpenCreateModal] = useState(false);
	const [openCampaignSelectModal, setOpenCampaignSelectModal] = useState(false);
	const [selectedCampaigns, setSelectedCampaigns] = useState([]); // holds array of _ids

	const [selectedView, setSelectedView] = useState(DASHBOARD_VIEWS.ORGANIZATIONAL);
	const [selectedFilter, setSelectedFilter] = useState([]);
	const [additionalFilters, setAdditionalFilters] = useState([]);
	const [details, setDetails] = useState({});
	const [conversationGraphData, setConversationGraphData] = useState([]);
	const [dateRange, setDateRange] = useState({
		from: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
		to: dayjs().format('YYYY-MM-DD'),
	});

	const [campaignData, setCampaignData] = useState([]);

	const company = useSelector((state) => state?.app?.company);
	const user = useSelector((state) => state.app.user);

	const NO_DATA = false;

	const getCampaigns = async () => {
		// setLoading(true);
		try {
			let res = await CultService.getCampaignBasicDetails({ params: { companyId: company?._id, status: ['live', 'completed'] } });
			setCampaignData(res?.data?.data || []);
			// console.log('Campaigns:', res?.data);
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
			// setLoading(false);
		}
	};
	const getDastboardStats = async () => {
		setLoading(true);
		const data = {};
		data.companyId = company?._id;
		data.viewType = selectedView?.LABEL;
		data.filters = selectedFilter?.values || undefined;
		data.filterType = selectedFilter?.type || undefined;
		data.additionalFilters = additionalFilters.length > 0 ? additionalFilters.map((i) => i?.code) : undefined;
		data.campaignIds = selectedCampaigns;
		try {
			let res = await CultService.getDashboardStats({ data });
			setDetails(res?.data?.data);
			// console.log('Dashboard Stats:', res?.data?.data);
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const handleGraphView = async ({ from, to }) => {
		try {
			let res = await CultService.getCallRecordingsDataForGraph({
				params: { from, to , campaignIds : selectedCampaigns},
			});

			setConversationGraphData(res?.data?.data || []);
		} catch (err) {
			toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
			// console.log('Error:', err);
		}
	};

	// Determine the color for CircularProgress based on the value
	const getCircularProgressColor = (value) => {
		if (value < 30) return [AppColors.ERROR_DARKER, AppColors.ERROR_LIGHTER]; // Red for values less than 30
		if (value >= 30 && value < 70) return [AppColors.WARNING_DARKER, AppColors.WARNING_LIGHTER]; // Yellow for values between 30 and 70
		return [AppColors.SUCCESS_DARKER, AppColors.SUCCESS_LIGHTER]; // Green for values greater than 70
	};

	const getFilters = async () => {
		let res = await CultService.getFilterValues({ params: { companyId: company?._id } });
		setFilters(res?.data);
	};

	useEffect(() => {
		if (company) {
			getDastboardStats();
			// handleGraphView(dateRange);

			getFilters();
		}
	}, [selectedView, selectedFilter, company, JSON.stringify(selectedCampaigns)]);

	useEffect(() => {
		handleGraphView(dateRange);
	}, [dateRange , JSON.stringify(selectedCampaigns)]);

	useEffect(() => {
		if (!company) return;
		getCampaigns();
	}, [company]);

	// Prepare data for LineGraphCard
	const lineGraphValues = useMemo(
		() =>
			conversationGraphData.map((item) => ({
				name: dayjs(item.date).format('DD MMM'),
				value: item.count,
			})),
		[conversationGraphData],
	);

	const localSettingColors = getColorSettings();

	return (
		<Stack sx={{ padding: 2 }}>
			<PageHeading
				title={`Hello ${user?.firstName} !`}
				titleSx={{ fontSize: 24, fontWeight: 600, lineHeight: '130%', fontFamily: 'Poppins, Arial, sans-serif' }}
				subTitle="Your current summary and activity."
				subTitleSx={{ fontSize: 1, fontWeight: 400, color: AppColors.LIGHT_GRAY, lineHeight: '150%' }}
				renderRight={
					<Stack direction="row" alignItems="center" gap={2}>
						{campaignData.length !== 0 && (
							<>
								<Button
									// onClick={() => navigate(PATH_NAME.CAMPAIGN_EDIT, { state: { fromDashboard: true } })}
									onClick={() => setOpenCreateModal(true)}
									startIcon={<AddIcon color={AppColors.WHITE} />}
									variant="contained"
									color="info"
								>
									Create Campaign
								</Button>
								<CustomInfoTooltip title="Filter by campaign" placement={'bottom'}>
									<Button
										// onClick={() => navigate(PATH_NAME.CAMPAIGN_EDIT, { state: { fromDashboard: true } })}
										onClick={() => setOpenCampaignSelectModal(true)}
										// startIcon={<AddIcon color={AppColors.WHITE} />}
										variant="contained"
										color="info"
									>
										Filter
									</Button>
								</CustomInfoTooltip>
							</>
						)}
					</Stack>
				}
			/>

			{campaignData.length === 0 ? (
				<DashboardEmptyView />
			) : (
				<Box sx={{ marginTop: '15px' }}>
					<Grid container spacing={3}>
						{/* Left Side Grid (9 columns) */}
						<Grid item xs={12} md={9}>
							{/* InfoCards */}
							<Stack mb={3}>
								<InfoCards details={details} />
							</Stack>

							<Grid container spacing={2}>
								{/* Left Side: 2x2 Cards */}
								<Grid item xs={12} md={6}>
									<Grid container spacing={2}>
										<Grid item xs={12} sm={6}>
											<StatisticsCard
												additionalFilters={additionalFilters}
												selectedFilter={selectedFilter}
												selectedView={selectedView}
												title="Response Rate"
												tooltip="Response rate represents the percentage of employees that have responded"
												value={details?.responseRate}
												monthChange={10}
												getCircularProgressColor={getCircularProgressColor}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<StatisticsCard
												hidePercentageSign
												additionalFilters={additionalFilters}
												selectedFilter={selectedFilter}
												selectedView={selectedView}
												title="Experience Score"
												tooltip="Employee experience score gauges employee confidence in leadership"
												value={details?.leadershipTrustScore}
												total={10}
												monthChange={10}
												getCircularProgressColor={getCircularProgressColor}
												mul={10}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<StatisticsCard
												
												additionalFilters={additionalFilters}
												selectedFilter={selectedFilter}
												selectedView={selectedView}
												title="Anonymous Response Rate"
												tooltip="Call information provides insights into the number of calls made"
												value={details?.ananonymousUsersRate}
												monthChange={10}
												getCircularProgressColor={getCircularProgressColor}
												isCallInfo={true}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<StatisticsCard
												
												additionalFilters={additionalFilters}
												selectedFilter={selectedFilter}
												selectedView={selectedView}
												title="Sentiment Score"
												tooltip="Sentiment score captures the collective emotional tone"
												value={details?.sentimentScore}
												monthChange={10}
												getCircularProgressColor={getCircularProgressColor}
											/>
										</Grid>
									</Grid>
								</Grid>

								{/* Right Side: Graph */}
								<Grid item xs={12} md={6}>
									<LineGraphCard
										value={null}
										values={details?.eNPS?.[0]?.trend || []}
										title="Employee Net Promoter Score"
										color={localSettingColors.fontColor}
										additionalFilters={additionalFilters}
										tooltipTitle={
											'A metric that measures employee loyalty by asking how likely they are to recommend the company as a place to work'
										}
									/>
								</Grid>
							</Grid>

							<Grid container spacing={2} mt={1.5}>
								<Grid item xs={12} md={6}>
									<BarGraphCard
										data={{
											AllCalls: details?.totalCalls || 0,
											Scheduled: details?.totalCallsScheduled || 0,
											Rescheduled: details?.totalCallsRescheduled || 0,
											Complete: details?.totalCallsComplete || 0,
											Pending: details?.totalCallsPending || 0,
										}}
										title="Call Statistics"
										borderRadius={7}
										colors={{
											color : localSettingColors.tertiary,
											backgroundColor : localSettingColors.buttonBackground,
										}
										} 
									/>
								</Grid>

								{/* <Grid item xs={12} md={6}>
									<BarGraphCard
										data={{
											Urgent: details?.callStatusCounts?.urgentCount || 0,
											Review: details?.callStatusCounts?.reviewCount || 0,
											Stable: details?.callStatusCounts?.stableCount || 0,
										}}
										title="Calls Status Count "
										colors={[AppColors.STATUS_RED, AppColors.STATUS_YELLOW, AppColors.STATUS_GREEN]} // Custom colors array
									/>
								</Grid> */}

								<Grid item xs={12} md={6}>
									<PieGraphCard
										data={{
											Urgent: details?.callStatusCounts?.urgentCount || 0,
											Review: details?.callStatusCounts?.reviewCount || 0,
											Stable: details?.callStatusCounts?.stableCount || 0,
										}}
										extraLables={['Signals of concern', 'Balance Reflection', 'Voice of Appreciation']}
										title="Calls Status Count"
										colors={['#FF718B', '#FFB33A', '#8FE88E']}
									/>
								</Grid>
							</Grid>

							{/* LineGraphCard */}

							{/* Full-Width Graph (Conversations Per Day) */}
							<Grid container spacing={2} mt={1.5}>
								<Grid item xs={12}>
									<LineGraphCard
										value={null}
										values={lineGraphValues} // Dummy data
										title="Conversations Per Day"
										showFilter
										xAxisSpace
										color={localSettingColors.tertiary}
										additionalFilters={additionalFilters}
										onDateRangeChange={setDateRange}
										tooltipTitle={
											'Breakdown of total participant responses, showing the percentage of users who opted for anonymous vs. non-anonymous conversations during participation.'
										}
									/>
								</Grid>
							</Grid>
						</Grid>

						{/* Right Side Grid (3 columns) */}
						<Grid item xs={12} md={3}>
							<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
								{/* Recent Conversations - top half */}
								<Box sx={{ minHeight: 100, maxHeight: 400, overflow: 'auto', mb: 2 }}>
									<ConversationList heading="Recent Conversations" data={details?.recentConversations} />
								</Box>
								{/* Harassment Tendency - middle */}
								<Box sx={{ minHeight: 100, maxHeight: 285, overflow: 'auto', borderRadius: '10px', mb: 2 }}>
									<ConversationList heading="Harassment Tendency" data={details?.harassmentTendencyRecordings} line={3} />
								</Box>
								{/* Suicidal Tendency - bottom */}
								<Box sx={{ minHeight: 100, maxHeight: 285, overflow: 'auto', borderRadius: '10px' }}>
									<ConversationList heading="Suicidal Tendency" data={details?.suicidalTendencyRecordings} line={3} />
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			)}

			{loading && <PageLoader />}

			{/* <Modal type="blur" open={open}>
				<CreateCampaignModal open={open} setOpen={setOpen} fetch={() => navigate(PATH_NAME.CAMPAIGN_LIST)} />
			</Modal> */}
			{
				<>
					<CampaignCreateOrDuplicateModal
						open={openCreateModal}
						onClose={() => setOpenCreateModal(false)}
						// fetchCampaigns={getList}
					/>
					<CampaignSelectDialog
						open={openCampaignSelectModal}
						onClose={() => setOpenCampaignSelectModal(false)}
						campaigns={campaignData || []}
						selectedCampaigns={selectedCampaigns}
						setSelectedCampaigns={setSelectedCampaigns}
					/>
				</>
			}
		</Stack>
	);
}
